// eslint-disable-next-line no-restricted-syntax
export enum CurrencyType {
  FIAT = 'fiat',
  VIRTUAL = 'virtual',
}
